import { CommentStatus } from './comment-status.enum';

export const emptyCommentData = {
  id: '',
  content: '',
  status: CommentStatus.Todo,
  isEditModeActive: true
};
